import { types } from 'mobx-state-tree';

import CollisionValues from '../definitions/CollisionValues';
import ComprehensiveValues from '../definitions/ComprehensiveValues';
import LiabilityValues from '../definitions/LiabilityValues';


const Coverage = types
    .model('Coverage', {
        comprehensive: types.optional(
            types.enumeration(Object.values(ComprehensiveValues)),
            ComprehensiveValues.ONE_THOUSAND,
        ),
        collision: types.optional(
            types.enumeration(Object.values(CollisionValues)),
            CollisionValues.ONE_THOUSAND,
        ),
        liability: types.optional(
            types.enumeration(Object.values(LiabilityValues)),
            LiabilityValues.ONE_MILLION,
        ),
        lossOfUse: false,
        rentalCarCoverage: false,
        accidentForgiveness: false,
        removingDepreciation: false,
    });
    
export default Coverage;
